<template>
  <div :class="$options.name">
    <div :class="[`${$options.name}__logo`, 'tw:relative tw:w-full tw:h-14 tw:min-h-14 tw:z-10']">
      <div
        v-if="!isPinned && !isHover"
        class="tw:p-2 tw:flex tw:justify-center tw:items-center tw:absolute tw:w-full tw:h-full"
      >
        <EdroneButtonIcon size="medium" type="plain" unique-id="main-menu__menu-expand-button">
          <font-awesome-icon icon="fa-light fa-angles-right" />
        </EdroneButtonIcon>
      </div>
      <div v-else class="tw:p-2 tw:flex tw:justify-between tw:items-center tw:flex-1 tw:absolute tw:w-full tw:h-full">
        <div class="tw:ms-2 tw:cursor-pointer" @click="handleOpenLiveEvents">
          <img :alt="trans._menu.header.logo" src="https://d3vhsxl1pwzf0p.cloudfront.net/logo-edrone-menu.svg" />
        </div>
        <EdroneButtonIcon type="plain" unique-id="main-menu__menu-pin-button" @click="$emit('toggleMenuPin')">
          <i v-if="isPinned" class="fa-kit fa-light-thumbtack-slash" />
          <font-awesome-icon v-else icon="fa-light fa-thumb-tack" />
        </EdroneButtonIcon>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import { gtagUniversalSend } from "vue-app/plugins/edroneGtag";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "MainMenuHeader",
  components: {
    EdroneButtonIcon,
  },
  props: {
    isPinned: Boolean,
    isHover: Boolean,
  },
  emits: ["keepHovered", "toggleMenuPin"],
  setup() {
    const router = useRouter();
    const user = window.EDRONE_CONTEXT.user;

    const handleOpenLiveEvents = () => {
      gtagUniversalSend({ component_id: "main-menu__logo-image" });
      router.push({
        path: "/app/live-events",
      });
    };

    return {
      user,
      handleOpenLiveEvents,
    };
  },
});
</script>
